import { Popover as P } from "radix-ui";
import { type ComponentProps, useContext } from "react";
import { cn } from "../../lib/utils";
import { InsideDialogContext } from "./dialog-context";
import { surface } from "./foundation";
export function Popover({ modal, ...props }: ComponentProps<typeof P.Root>) {
  const insideDialog = useContext(InsideDialogContext);
  // A dialog locks body scrolling. Its portalled picker needs its own scroll boundary.
  return <P.Root {...props} modal={modal ?? insideDialog} />;
}
export const PopoverTrigger = P.Trigger;
export const PopoverAnchor = P.Anchor;
export function PopoverContent({
  className,
  sideOffset = 6,
  align = "start",
  ...props
}: ComponentProps<typeof P.Content>) {
  return (
    <P.Portal>
      <P.Content
        {...props}
        sideOffset={sideOffset}
        align={align}
        data-slot="popover-content"
        className={cn("cyra-popup p-3", className)}
      />
    </P.Portal>
  );
}
export const PopoverHeader = surface("div", "popover-header", "space-y-1");
export const PopoverTitle = surface("h3", "popover-title", "font-medium");
export const PopoverDescription = surface(
  "p",
  "popover-description",
  "text-sm text-muted-foreground",
);
